import React, { Component } from "react";
import axios from "axios";
import { END_POINT } from "./endPoint";

export const DeviceContext = React.createContext();

export default class DeviceProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allDevicesList: 
        JSON.parse(localStorage.getItem("allDevicesList")) || [],
      partsList: 
        JSON.parse(localStorage.getItem("partsList")) || [],
      partsStatusList:
        JSON.parse(localStorage.getItem("partsStatusList")) || [],
      deviceSerialList:
        JSON.parse(localStorage.getItem("deviceSerialList")) || [],
      clpSerialList: 
        JSON.parse(localStorage.getItem("clpSerialList")) || [],
      deviceModelList:
        JSON.parse(localStorage.getItem("deviceModelList")) || [],
      allApiDevicesList:
        JSON.parse(localStorage.getItem("allApiDevicesList")) || [],
      maintenanceList:
        JSON.parse(localStorage.getItem("maintenanceList")) || [],
      serviceListDv:
        JSON.parse(localStorage.getItem("serviceListDv")) || [],
     
    };
  }

  getAllLinkDevice = async (data) => {
    await axios
      .post(`${END_POINT}/get_all_linked_device`, data)
      .then((res) => {
        console.log("dataAll",res.data);
        if (res.status === 200) {
          localStorage.setItem(
            "allDevicesList",
            JSON.stringify(res.data.linkedDevices)
          );
          this.setState({ allDevicesList: res.data.linkedDevices });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return this.state.allDevicesList;
  };

  getAllLink = async (data) => {
    await axios
      .post(`${END_POINT}/get_all_linke`, data)
      .then((res) => {
        console.log("dataAlllinke",res.data);
        if (res.status === 200) {
          localStorage.setItem(
            "allLinkeList",
            JSON.stringify(res.data.linkedDevices)
          );
          this.setState({ allDevicesList: res.data.linkedDevices });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return this.state.allDevicesList;
  };


  getAllLinkDevices = async (data) => {
    await axios
      .post(`${END_POINT}/get_all_linked_devices`, data)
      .then((res) => {
        console.log("dataAll",res.data);
        if (res.status === 200) {
          localStorage.setItem(
            "allDevicesList",
            JSON.stringify(res.data.linkedDevices)
          );
          this.setState({ allDevicesList: res.data.linkedDevices });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return this.state.allDevicesList;
  };

  getMA = async (data) => {
    try{
      const response =  await axios.post(`${END_POINT}/get/maintenance`, data)
      console.log("MAdatass", response.data);
      if (response.data != null) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  masterDeviceSerials = async (data) => {
    await axios
      .post(`${END_POINT}/get/master_device_serials`, data)
      .then((res) => {
        if (res.status === 200 && res.data.status.result === "success") {
          localStorage.setItem(
            "deviceSerialList",
            JSON.stringify(res.data.data)
          );
          this.setState({ deviceSerialList: res.data.data });
        } else {
          console.log(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteDeviceSerial = async (data) => {
    let result = null;
    console.log("result",data);
    await axios
      .post(`${END_POINT}/delete/device_serial`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };


  machineLocation = async (data) => {
    try {
      const response = await axios.post(`${END_POINT}/get/machine_location`,data);
      // console.log("Locationdata", response.data);
      if (response.data != null) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  masterClpSerials = async (data) => {
    await axios
      .post(`${END_POINT}/get/master_clp_serials`, data)
      .then((res) => {
        if (res.status === 200 && res.data.status.result === "success") {
          localStorage.setItem("clpSerialList", JSON.stringify(res.data.data));
          this.setState({ clpSerialList: res.data.data });
        } else {
          console.log(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteClpSerials = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/clp_serial`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  masterDeviceModels = async (data) => {
    await axios
      .post(`${END_POINT}/get/master_device_models`, data)
      .then((res) => {
        if (res.status === 200 && res.data.status.result === "success") {
          localStorage.setItem(
            "deviceModelList",
            JSON.stringify(res.data.data)
          );
          this.setState({ deviceModelList: res.data.data });
        } else {
          console.log(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteMotorModel = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/motor_model`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  uploadMasterDeviceData = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/upload/master_data`, data)
      .then((res) => {
        console.log(res.data);
        result = res.data;
      })
      .catch((error) => alert(error));

    return result;
  };

  addMasterDeviceSerial = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/add/master_device_serial`, data)
      .then((res) => {
        console.log(res.data);
        result = res.data;
      })
      .catch((error) => alert(error));

    return result;
  };

  addMasterClpSerial = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/add/master_clp_serial`, data)
      .then((res) => {
        console.log(res.data);
        result = res.data;
      })
      .catch((error) => alert(error));

    return result;
  };

  mappingDeviceModel = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/mapping_device_model`, data)
      .then((res) => {
        console.log(res.data);
        result = res.data;
      })
      .catch((error) => alert(error));

    return result;
  };

  deleteDeviceModel = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/device_model`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  getClpMemberAll = async () => {
    try {
      const response = await axios.post(`${END_POINT}/get/clp_member_line_all`);
      console.log("MemberListAll", response.data.memberListAll);
      if (response.status === 200) {
        localStorage.setItem("MemberListAlls", JSON.stringify(response.data.memberListAll));
        return response.data.memberListAll;
      }
    } catch (error) {
      console.log(error);
    }
  };

  getClpMembers = async () => {
    try {
      const response = await axios.post(`${END_POINT}/get/clp_member_line`);
      // console.log("ClpMemberList", response.data.memberList);
      if (response.status === 200) {
        localStorage.setItem("ClpMemberList", JSON.stringify(response.data.memberList));
        return response.data.memberList;
      }
    } catch (error) {
      console.log(error);
    }
  };



  // ! -------------------------------- Parts -------------------------------- ! //

  getMasterParts = async (data) => {
    await axios
      .post(`${END_POINT}/get/master_parts`, data)
      .then((res) => {
        // console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("partsList", JSON.stringify(res.data.parts));
          this.setState({ partsList: res.data.parts });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteParts = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/part`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  importMasterParts = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/import/master_data`, data)
      .then((res) => {
        console.log("MasterParts",  res.data);
        if (res.data.status.code === 0) {
            result = res.data.status.description;
            this.getMasterParts({ model: null });
        } 
        else {
            result = res.data.status.description;
        }
          console.log(res.data.status.description);
      })
      .catch((error) => console.log(error));
    return result;
  };

  getPastStatus = async (data) => {
    await axios
      .post(`${END_POINT}/get/part_status`, data)
      .then((res) => {
        // console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("partsStatusList", JSON.stringify(res.data));
          this.setState({ partsStatusList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiAllDevice = async (data) => {
    await axios
      .post(`${END_POINT}/get/part_status`, data)
      .then((res) => {
        // console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("partsStatusList", JSON.stringify(res.data));
          this.setState({ partsStatusList: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getService = async () => {
    let result = null;
    await axios
      .post(`${END_POINT}/get/service`)
      .then((res) => {
        console.log("dataservice",res.data);
        if (res.status === 200) {
            result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
      return result;
  };

  render() {
    const dataDevices = {
      allDevicesList: this.state.allDevicesList,
      partsList: this.state.partsList,
      partsStatusList: this.state.partsStatusList,
      deviceSerialList: this.state.deviceSerialList,
      clpSerialList: this.state.clpSerialList,
      deviceModelList: this.state.deviceModelList,
      LocationList: this.state.LocationList,
      maintenanceList: this.maintenanceList,
      serviceListDv: this.serviceListDv,
      

      // ! -------------- DEVICE --------------
      getAllLink: this.getAllLink,
      getAllLinkDevice: this.getAllLinkDevice,
      getAllLinkDevices: this.getAllLinkDevices,
      masterDeviceSerials: this.masterDeviceSerials,
      deleteDeviceSerial: this.deleteDeviceSerial,
      masterClpSerials: this.masterClpSerials,
      deleteClpSerials: this.deleteClpSerials,
      masterDeviceModels: this.masterDeviceModels,
      deleteMotorModel: this.deleteMotorModel,
      uploadMasterDeviceData: this.uploadMasterDeviceData,
      addMasterDeviceSerial: this.addMasterDeviceSerial,
      addMasterClpSerial: this.addMasterClpSerial,
      mappingDeviceModel: this.mappingDeviceModel,
      deleteDeviceModel: this.deleteDeviceModel,
      machineLocation: this.machineLocation,
      getMA: this.getMA,
      getClpMemberAll: this.getClpMemberAll,
      getClpMembers: this.getClpMembers,

      // ! -------------- PARTS --------------
      getMasterParts: this.getMasterParts,
      deleteParts: this.deleteParts,
      importMasterParts: this.importMasterParts,
      getPastStatus: this.getPastStatus,
      getService: this.getService,
    };

    return (
      <DeviceContext.Provider value={dataDevices}>
        {this.props.children}
      </DeviceContext.Provider>
    );
  }
}
